export default "__VITE_ASSET__Dfkf0Lar__"